import Model from '@/models/Model.js';

export default class SystemAlert extends Model {
    static entity = 'system_alerts';

    static modelName = 'SystemAlert';

    static fields() {
        return {
            id: this.attr(null),
            uuid: this.attr(null),
            course_id: this.attr(null),
            priority: this.attr(null),
            title: this.attr(null),
            caption: this.attr(null),
            body: this.attr(null),
            icon: this.attr(null),
            color: this.attr(null),
            action_path: this.attr(null),
            location: this.attr(null),
            channels: this.attr(null),
            permissions: this.attr(null),
            roles: this.attr(null),
            starts_at: this.attr(null),
            expires_at: this.attr(null),
            dismissable: this.boolean(true),
            notify_via_site: this.boolean(true),
            notify_via_email: this.boolean(false),
            notify_via_text: this.boolean(false),
            notify_via_push: this.boolean(false),
            notify_via_slack: this.boolean(false),

            ...super.fields(),

            course: this.belongsTo('courses', 'course_id'),
        };
    }

    static beforeSelect(systemAlerts) {
        const dismissed = JSON.parse(localStorage.getItem('dismissed-system-alerts')) || [];

        return systemAlerts
            .filter(systemAlert => !dismissed.includes(systemAlert.id))
            .sort((a, b) => (a.priority > b.priority ? 1 : b.priority > a.priority ? -1 : 0));
    }
}
